"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'Hunter',
  bodyClass: 'hunter-page',
  components: {},
  data: function data() {
    return {
      // VUE_APP_BASE_URL_HUNTER aponta para o proxy da Hive (hunter.hiveplace.com.br),
      // que encaminha para a Serasa removendo o X-Frame-Options e viabiliza o embed.
      // Não trocar para o host direto da Serasa (o iframe voltaria a ser bloqueado).
      uriPortal: process.env.VUE_APP_BASE_URL_HUNTER || '/Hunter/Splash/splash.aspx'
    };
  },
  mounted: function mounted() {
    // Monitora o iframe para possíveis problemas
    // this.$nextTick(() => {
    //   const iframe = this.$refs.hunterIframe
    //   if (iframe) {
    //     iframe.onload = () => {
    //       console.log('Hunter iframe carregado')
    //     }
    //   }
    // })
  },
  methods: {
    goBack: function goBack() {
      this.$router.back();
    }
  }
};